import ValueWithLabelCard from 'src/components/primitives/ValueWithLabelCard/ValueWithLabelCard';
import usePortfolioEarnData from 'src/components/PortfolioPage/PortfolioEarnSubPage/hooks/usePortfolioEarnData';
import PortfolioStatsCardItem from 'src/components/PortfolioPage/PortfolioStatsCardItem';

export default function PortfolioEarnStatsCard() {
	const {
		data: { totalDeposits, totalBorrows, avgDepositApy, total90DayEarning },
		isLoading,
	} = usePortfolioEarnData();

	return (
		<ValueWithLabelCard.Container className="justify-between">
			<PortfolioStatsCardItem
				label="Your Deposits"
				value={totalDeposits}
				displayType="currency"
				valueClassName="text-text-default"
				skeletonPlaceholderClassName="w-20"
				loading={isLoading}
				isAccountValueToHide
			/>
			<PortfolioStatsCardItem
				label="Your Borrows"
				value={totalBorrows}
				displayType="currency"
				valueClassName={totalBorrows ? 'text-star-yellow' : 'text-text-default'}
				skeletonPlaceholderClassName="w-14"
				loading={isLoading}
				isAccountValueToHide
			/>
			<PortfolioStatsCardItem
				label="Total Earning APY"
				value={avgDepositApy}
				displayType="percentage"
				valueClassName="text-text-default"
				tooltipDefinitionId="portfolioTotalEarningApy"
				skeletonPlaceholderClassName="w-16"
				loading={isLoading}
				signDependentColor
			/>
			<PortfolioStatsCardItem
				label="Total 90D Earnings"
				value={total90DayEarning}
				displayType="currency"
				valueClassName="text-text-default"
				tooltipDefinitionId="portfolioTotal90DEarning"
				skeletonPlaceholderClassName="w-18"
				loading={isLoading}
				signDependentColor
				isAccountValueToHide
			/>
		</ValueWithLabelCard.Container>
	);
}
